<div class="c-widget--copy-referral c-widget--balance --in-row mr-16 -manager" [class.-loading]="isLoading" (click)="copy()">
  <div class="right-wrapper">
    <div class="d-flex align-items-center button-bg">
      <div class="c-widget--copy-referral--inner-text">
        <div>
          <ng-container *ngIf="showCopiedMessage" i18n="@@common.copied"> Copied! </ng-container>
          <ng-container *ngIf="!showCopiedMessage" i18n="@@common.copy_group_link"> Copy group link </ng-container>
        </div>
        <div>
          <p500-ui-icon name="buttons-copy-big" class="ml-10"></p500-ui-icon>
        </div>
      </div>
    </div>
  </div>
</div>
